import { Component, OnInit, HostBinding, TemplateRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { asyncScheduler, Observable } from 'rxjs';
import { tap, map, startWith, observeOn } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AdaptiveService } from '@uxdf/direct-shared-lib';

import { State as ReportState } from '../../../../redux/reducers/invoices/reducers-segments-report';
import { State as OptionsState } from '../../../../redux/reducers/invoices/reducers-segments-options';
import { getSegmentsReport, getSegmentsOptions } from '../../../../redux/reducers';
import { ReportFileService } from '../../../../redux/services/report-file.service';
import { Options } from '../../../../redux/models/invoices/segments.options.model';

@Component({
  standalone: false,
  selector: 'app-invoices-segments',
  templateUrl: './segments.component.html'
})
export class SegmentsComponent implements OnInit {
  @HostBinding() class = 'invoices-segments';
  showDisclaimer = false;
  loading = false;
  buttonsAllowed: boolean;
  showProviders: boolean;
  isDesktop$: Observable<boolean>;
  reportState$: Observable<ReportState>;
  optionsState$: Observable<Options>;

  constructor(
    private readonly modalService: NgbModal,
    private readonly adaptiveService: AdaptiveService,
    private readonly store: Store<ReportState>,
    private readonly reportFileService: ReportFileService
  ) {}

  ngOnInit() {
    this.reportState$ = this.store.pipe(
      select(getSegmentsReport),
      observeOn(asyncScheduler),
      tap(report => {
        this.loading = report.updateRequired;
        this.buttonsAllowed = !report.errorMessage && report.data.byDate && report.data.byDate.length > 0;
        this.showProviders = this.buttonsAllowed && report.data.providers && report.data.providers.length > 0;
      })
    );
    this.optionsState$ = this.store.pipe(
      select(getSegmentsOptions),
      map((state: OptionsState) => state.data)
    );
    this.isDesktop$ = this.adaptiveService.getResizeEvent().pipe(
      startWith(this.adaptiveService.isDesktop()),
      map(() => this.adaptiveService.isDesktop())
    );
  }

  showModal(template: TemplateRef<any>) {
    this.modalService.open(template, { centered: true });
  }

  loadReportFile() {
    this.loading = true;
    this.reportFileService.loadFile().subscribe(() => (this.loading = false));
  }

  getTitleKey(segment: string): string {
    return segment ? 'accountInvoicesProvidersRanking' : 'accountInvoicesSegmentsRanking';
  }

  getButtonKey(segment: string): string {
    return segment ? 'accountInvoicesShowProvidersRanking' : 'accountInvoicesShowSegmentsRanking';
  }
}
